// features/profile/edit/editSections.ts — the Edit Profile sub-nav: each entry jumps to
// the card with that id on /settings/profile (1.27.70).
import type { IconName } from '@/icons/names';

export const EDIT_SECTIONS: { id: string; label: string; icon: IconName }[] = [
  { id: 'photo', label: 'Profile', icon: 'user' },
  { id: 'basic', label: 'Basic Info', icon: 'info' },
  { id: 'about', label: 'About & Identity', icon: 'file-text' },
  { id: 'links', label: 'Links', icon: 'link' },
  { id: 'appearance', label: 'Appearance', icon: 'palette' },
  { id: 'privacy', label: 'Privacy', icon: 'lock' },
  { id: 'interests', label: 'Interests', icon: 'hash' },
  { id: 'verification', label: 'Verification', icon: 'shield' },
];
